var Preferences = {
    empty: {        
        email: false,
        sms: false
    },
    full: {        
        email: true,
        sms: false
    }
};

function getPreferences(email, callback) {
    var req = new XMLHttpRequest();
    req.open('GET', cpmURL + '?email=' + email);
    req.setRequestHeader('X-Api-Key', cpmKey);
    req.addEventListener('load', function(e) {
        var body = JSON.parse(this.response);
        if(this.status == 200) {
            var preferences = body.preferences;
            callback(null, preferences);
        } else {
            callback({ status: this.status, message: body.message });
        }
    });
    req.send();
}

function setPreferences(email, preferences, callback) {
    var req = new XMLHttpRequest();
    req.timeout = 4900;
    req.onload = function(e) {
        var body = JSON.parse(this.response);
        if(this.status == 200) {
            callback(null);
        } else {
            callback({ status: this.status, message: body.message });
        }
    };
    req.ontimeout = function(e) {
        console.log('timeout, retrying...');
        setPreferences(email, preferences, callback);
    };
    req.open('POST', cpmURL + '?email=' + email);
    req.setRequestHeader('X-Api-Key', cpmKey);
    req.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');

    req.send(JSON.stringify({ preferences: preferences }));
}

function setPreferencesFull(email, callback) {
    setPreferences(email, Preferences.full, callback);
}

function setPreferencesEmpty(email, callback) {
    setPreferences(email, Preferences.empty, callback);
}